export default __webpack_public_path__ + "static/media/poster.45c992fc.jpg";